function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import React from "react";

var _ref2 = /*#__PURE__*/React.createElement("path", {
  clipRule: "evenodd",
  d: "m14 28c-7.73199 0-14-6.268-14-14 0-7.73199 6.26801-14 14-14 7.732 0 14 6.26801 14 14-.0078 7.7287-6.2713 13.9922-14 14zm0-26.5744c-5.08759 0-9.67419 3.0649-11.62082 7.7654-1.946615 4.7005-.86985 10.1108 2.72816 13.7078s9.00856 4.6722 13.70856 2.7243c4.6999-1.948 7.7635-6.5355 7.7621-11.6231-.0059-6.9436-5.6344-12.57048-12.578-12.5744zm5.1691 10.0574-6.0437 6.0437c-.1333.1322-.3135.2063-.5012.2062-.189.001-.3707-.0731-.5049-.2062l-3.29199-3.2956c-.27783-.2778-.27783-.7283 0-1.0061.27782-.2778.72826-.2778 1.00609 0l2.7908 2.7943 5.5388-5.5424c.2778-.2778.7283-.2778 1.0061 0s.2778.7283 0 1.0061z",
  fill: "#516e85",
  fillRule: "evenodd"
});

var SvgListIcon = function SvgListIcon(_ref) {
  var svgRef = _ref.svgRef,
      title = _ref.title,
      props = _objectWithoutProperties(_ref, ["svgRef", "title"]);

  return /*#__PURE__*/React.createElement("svg", _extends({
    fill: "none",
    height: 28,
    viewBox: "0 0 28 28",
    width: 28,
    ref: svgRef
  }, props), title ? /*#__PURE__*/React.createElement("title", null, title) : null, _ref2);
};

var ForwardRef = /*#__PURE__*/React.forwardRef(function (props, ref) {
  return /*#__PURE__*/React.createElement(SvgListIcon, _extends({
    svgRef: ref
  }, props));
});
export default __webpack_public_path__ + "static/media/ListIcon.d50083d9.svg";
export { ForwardRef as ReactComponent };